import Page2024 from './Page2024';
export default Page2024;
